import PropTypes from 'prop-types';
var propTypes = {
  appearance: PropTypes.oneOf(['singlecolor', 'multicolor']),
  background: PropTypes.oneOf(['light', 'dark', 'auto'])
};
export default propTypes;